// Others
import axiosClient from './axiosClient';
import { urlApiContact } from '~/utils/constants/apis';
import {
  IBodySendMail,
  IBodyUpdateContact,
  IContact,
  IContactDetail,
  IContactForm,
  IQueryDeleteContact,
  IQueryParamContact,
} from '~/utils/interface/contact';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { CONTENT_TYPE_FORM_DATA } from '~/utils/constants/common';

const contactApi = {
  createContact: (payload: IContactForm) => {
    const url = urlApiContact.createContact;
    return axiosClient.post<IBaseResponse>(url, payload);
  },

  getContactList: (params: IQueryParamContact) => {
    const url = urlApiContact.getContactList;
    return axiosClient.get<IBaseResponse<IListDataResponse<IContact[]>>>(url, { params });
  },

  getContactDetail: (id: string) => {
    const url = urlApiContact.getContactDetail(id);
    return axiosClient.get<IBaseResponse<IContactDetail>>(url);
  },

  updateContact: (payload: IBodyUpdateContact) => {
    const { id, body } = payload;
    const url = urlApiContact.updateContact(id);
    return axiosClient.put<IBaseResponse>(url, body);
  },

  sendEmail: (params: IBodySendMail) => {
    const { id, body } = params;
    const url = urlApiContact.sendEmail(id);
    return axiosClient.post<IBaseResponse>(url, body, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  convertToCustomer: (id: string) => {
    const url = urlApiContact.convertToCustomer(id);
    return axiosClient.put<IBaseResponse>(url);
  },

  deleteContact: (params: IQueryDeleteContact) => {
    const url = urlApiContact.deleteContact;
    return axiosClient.delete<IBaseResponse>(url, { params });
  },
};

export default contactApi;
